export const Wizard = {
  PRIVATE: 'NATURAL',
  CORPORATE: 'LEGAL',
}
